export enum AnimationNameGame1 {
    Running = 'RUNNING',
    Stunned = 'STUNNED',
}

export enum AnimationNameGame2 {
    Running = 'RUNNING',
}
